export const sortByPosition = arr => arr.sort((a, b) => a.position - b.position);

export const sortByPin = arr => arr.sort((a, b) => b.pin - a.pin);